module.exports = __webpack_public_path__ + "img/roundtable.f76fadfd.png";